import React from 'react';
import { ReactComponent as Mvc } from '../../images/mvc.svg';
import { ReactComponent as MvcLogo } from '../../images/mvc_logo.svg';
import { ReactComponent as Westin } from '../../images/westin.svg';
import { ReactComponent as Sheraton } from '../../images/sheraton.svg';
import { ReactComponent as GrandResidence } from '../../images/grandResidence.svg';
import { ReactComponent as RitzCarlton } from '../../images/ritzCarlton.svg';
import { ReactComponent as StRegis } from '../../images/stRegis.svg';
import './logout.css';
import * as Constants from '../url-constant';

const Logout = () => {
	const preventBack = () => {
		window.history.forward();
	};
	window.onload = preventBack;
	window.onpageshow = (evt) => {
		if (evt.persisted) preventBack();
	};
	const logout = () => {
		window.location.href = `${Constants.redirectURL}`;
		preventBack();
	};
	return (
		<div className='container-logout'>
			<div className='container-l-logout'>
				<div className='logoAlign-logout'>
					<Mvc />
				</div>
				<div className='imgTitle-logout'>
					<h5> Election Exchange Engine</h5>
				</div>
			</div>
			<div className='container-r-logout'>
				<div className='linkSection-logout'>
					<div className='title-logout'>You have logged out.</div>
					<div className='subTitle-logout'>Forgot to do something?</div>
					<div>
						<button className='primary' onClick={logout}>
							LOGIN
						</button>
					</div>
					<div className='wrapper'>
						<div>
							<span className='MvcLogo'>
								<MvcLogo />
							</span>
						</div>
						<div>
							<span className='Sheraton'>
								<Sheraton />
							</span>
						</div>
						<div>
							<span className='Westin'>
								<Westin />
							</span>
						</div>
						<div>
							<span className='GrandResidence'>
								<GrandResidence />
							</span>
						</div>
						<div>
							<span className='RitzCarlton'>
								<RitzCarlton />
							</span>
						</div>
						<div>
							<span className='StRegis'>
								<StRegis />
							</span>
						</div>
					</div>
					<div className='copyRightLogout'>
						<p>
							&#169;2021 Copyright by Marriott Vacations Worldwide.All rights
							reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Logout;
